import { createFileRoute } from '@tanstack/react-router'
import { AppUserList } from '@/features/app-users/pages/app-user-list'

export const Route = createFileRoute('/_authenticated/app-users/')({
  component: RouteComponent,
})

function RouteComponent() {
  return <AppUserList />
}
